import { environment } from '../../environments/environment';

export const ENVIRONMENT = 'environment';
export type Environment = typeof environment;
